import React from 'react'
import { Table } from '../../../../../../components/Table'
import { TableHead } from '../../../../../../components/Table/TableHead'
import { TableBody } from '../../../../../../components/Table/TableBody'
import RequisiteAuditRow from './RequisiteAuditRow'
import { IRequisiteAuditItem } from '../core/response.types'

interface Props {
  items: IRequisiteAuditItem[]
  loading: boolean
}

const COLS = 3

const RequisiteAuditTable: React.FC<Props> = ({ items, loading }) => (
  <Table>
    <TableHead>
      <tr>
        <th style={{ width: 200 }}>Когда</th>
        <th style={{ width: 280 }}>Кто</th>
        <th>Что сделал</th>
      </tr>
    </TableHead>
    <TableBody>
      {loading ? (
        <tr><td colSpan={COLS} className='text-center py-5'>Загрузка...</td></tr>
      ) : items.length === 0 ? (
        <tr><td colSpan={COLS} className='text-center py-5 text-muted'>Записей не найдено</td></tr>
      ) : (
        items.map(it => <RequisiteAuditRow key={it.id} item={it} />)
      )}
    </TableBody>
  </Table>
)

export default RequisiteAuditTable
